import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { ModalEl } from "common/components/modal";
import { MarkdownEl } from "common/components/markdown";
import { LanguageSelectorEl } from "common/widgets/language-selector";
import { EventCarouselEl } from "./event-carousel";
import onboardingShapes from "./images/onboarding-shapes.svg";
import onboardingDashboard from "./images/onboarding-dashboard.svg";
import kathyImg from "./images/profiles/kathy.svg";
import jillImg from "./images/profiles/jill.svg";
import bradImg from "./images/profiles/brad.svg";
import bradAnimatedGif from "./images/profiles/brad-animated.gif";
export function template() {
  const Profile = ({ idx, src }) => /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".profile",
      class: {
        [`profile-fg-${idx}`]: true
      },
      key: `profile${idx}`
    },
    /* @__PURE__ */ jsx("div", { sel: ".profile-img" }, /* @__PURE__ */ jsx(
      "img",
      {
        attrs: {
          src,
          alt: `user`,
          draggable: `false`,
          width: `100%`
        }
      }
    ))
  );
  const SkipButton = () => /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: ".skip-button",
      attrs: {
        theme: ButtonTheme.Tertiary,
        href: this.helpers.appendMpSource(`intro-skip`)
      }
    },
    this.t(`signup.intro.skip`)
  );
  const NextButton = () => /* @__PURE__ */ jsx(ButtonEl, { sel: ".next-button", attrs: { theme: ButtonTheme.Primary }, on: { click: this.helpers.nextStep } }, this.t(`signup.intro.next`, { emoji: `\u2192` }));
  const StepButton = ({ index, step: step2 }) => /* @__PURE__ */ jsx(
    "div",
    {
      sel: ".step-button",
      class: { active: step2.active, visited: step2.visited, [step2.name]: true },
      on: { click: () => this.helpers.handleStepClick(index) }
    },
    /* @__PURE__ */ jsx("div", { sel: ".step-button-content" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: step2.icon } }), /* @__PURE__ */ jsx("div", { sel: ".step-button-label" }, this.print(step2.text))),
    /* @__PURE__ */ jsx("div", { sel: ".step-button-indicator" }, step2.visited ? /* @__PURE__ */ jsx(SvgIconEl, { attrs: { icon: `circle-checkmark` } }) : /* @__PURE__ */ jsx("div", { sel: ".step-button-index" }, index + 1))
  );
  const OverviewCopy = () => /* @__PURE__ */ jsx("div", { sel: ".content" }, /* @__PURE__ */ jsx("div", { sel: ".content-container" }, /* @__PURE__ */ jsx("h1", { sel: ".title" }, this.attr(`first-name`) ? this.t(`signup.intro.hi-first-name`, { firstName: this.attr(`first-name`) }) : this.t(`signup.intro.hi-no-name`)), /* @__PURE__ */ jsx("h1", { sel: ".title" }, this.t(`signup.intro.welcome`)), /* @__PURE__ */ jsx("p", { sel: ".text" }, this.t(`signup.intro.mixpanel-overview`)), /* @__PURE__ */ jsx("p", { sel: ".text" }, this.t(`signup.intro.key-concepts`)), /* @__PURE__ */ jsx(ButtonEl, { sel: ".next-button", attrs: { theme: ButtonTheme.Primary }, on: { click: this.helpers.nextStep } }, this.t(`signup.intro.get-started`)), this.attr(`is-full-page`) && /* @__PURE__ */ jsx(SkipButton, null)));
  const OverviewImages = () => /* @__PURE__ */ jsx("div", { sel: ".images" }, /* @__PURE__ */ jsx("div", { sel: ".image-container" }, /* @__PURE__ */ jsx("div", { sel: ".shapes-fg-1" }, /* @__PURE__ */ jsx(
    "img",
    {
      attrs: {
        src: onboardingShapes,
        alt: `shapes`,
        width: 400,
        height: `auto`,
        draggable: `false`
      },
      key: "shapes1"
    }
  ))));
  const UsersCopy = () => /* @__PURE__ */ jsx("div", { sel: ".content" }, /* @__PURE__ */ jsx("div", { sel: ".content-container" }, /* @__PURE__ */ jsx("h1", { sel: ".title" }, this.t(`signup.intro.unique-user`)), /* @__PURE__ */ jsx("p", { sel: ".text" }, this.t(`signup.intro.cafe-owner`)), /* @__PURE__ */ jsx("p", { sel: ".text" }, this.t(`signup.intro.cafe-customer`)), /* @__PURE__ */ jsx("p", { sel: ".text" }, /* @__PURE__ */ jsx(MarkdownEl, { attrs: { text: this.t(`signup.intro.customer-details`) } })), /* @__PURE__ */ jsx(NextButton, null), this.attr(`is-full-page`) && /* @__PURE__ */ jsx(SkipButton, null)));
  const UsersImages = () => /* @__PURE__ */ jsx("div", { sel: ".images" }, /* @__PURE__ */ jsx("div", { sel: ".image-container" }, /* @__PURE__ */ jsx(Profile, { idx: 1, src: kathyImg }), /* @__PURE__ */ jsx(Profile, { idx: 2, src: jillImg }), /* @__PURE__ */ jsx(Profile, { idx: 3, src: bradImg })));
  const EventsCopy = () => /* @__PURE__ */ jsx("div", { sel: ".content" }, /* @__PURE__ */ jsx("div", { sel: ".content-container" }, /* @__PURE__ */ jsx("h1", { sel: ".title" }, this.t(`signup.intro.track-action`)), /* @__PURE__ */ jsx("p", { sel: ".text" }, /* @__PURE__ */ jsx(MarkdownEl, { attrs: { text: this.t(`signup.intro.purchase-details`) } })), /* @__PURE__ */ jsx("p", { sel: ".text" }, /* @__PURE__ */ jsx(MarkdownEl, { attrs: { text: this.t(`signup.intro.user-action`) } }), /* @__PURE__ */ jsx(MarkdownEl, { attrs: { text: this.t(`signup.intro.action-details`) } })), /* @__PURE__ */ jsx(NextButton, null), this.attr(`is-full-page`) && /* @__PURE__ */ jsx(SkipButton, null)));
  const EventsImages = () => /* @__PURE__ */ jsx("div", { sel: ".images" }, /* @__PURE__ */ jsx("div", { sel: ".image-container" }, /* @__PURE__ */ jsx("div", { sel: ".event-carousel-container" }, /* @__PURE__ */ jsx(EventCarouselEl, null))));
  const ProfilesCopy = () => /* @__PURE__ */ jsx("div", { sel: ".content" }, /* @__PURE__ */ jsx("div", { sel: ".content-container" }, /* @__PURE__ */ jsx("h1", { sel: ".title" }, this.t(`signup.intro.profiles-purpose`)), /* @__PURE__ */ jsx("p", { sel: ".text" }, /* @__PURE__ */ jsx(MarkdownEl, { attrs: { text: this.t(`signup.intro.mixpanel-consolidates`) } })), /* @__PURE__ */ jsx("p", { sel: ".text" }, this.t(`signup.intro.uncover-insights`)), /* @__PURE__ */ jsx(NextButton, null), this.attr(`is-full-page`) && /* @__PURE__ */ jsx(SkipButton, null)));
  const CompleteCopy = () => /* @__PURE__ */ jsx("div", { sel: ".content" }, /* @__PURE__ */ jsx("div", { sel: ".content-container" }, /* @__PURE__ */ jsx("h1", { sel: ".title" }, this.t(`signup.intro.great-work`, { emoji: ` \u{1F389}` })), /* @__PURE__ */ jsx("p", { sel: ".text" }, this.t(`signup.intro.ready-to-start`)), /* @__PURE__ */ jsx("p", { sel: ".text.dashboards-notice" }, this.t(`signup.intro.boards-overview`)), this.attr(`is-full-page`) ? /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: ".next-button",
      attrs: { theme: ButtonTheme.Primary, href: this.helpers.appendMpSource(`intro-complete`) }
    },
    this.getCtaCopy()
  ) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: ".next-button",
      attrs: { theme: ButtonTheme.Primary },
      on: { click: this.helpers.onCloseButtonClick }
    },
    this.getCtaCopy()
  ), /* @__PURE__ */ jsx(
    ButtonEl,
    {
      sel: ".learn-more-button",
      attrs: {
        href: `https://mixpanel.com/api/app/demo_project`,
        theme: ButtonTheme.Tertiary,
        target: `_blank`
      }
    },
    this.t(`signup.intro.view-demo`)
  ))));
  const CompleteImagesDashboard = () => /* @__PURE__ */ jsx("div", { sel: ".images" }, /* @__PURE__ */ jsx("div", { sel: ".image-container" }, /* @__PURE__ */ jsx("div", { sel: ".ellipse-bg.hide-overhang" }, /* @__PURE__ */ jsx("div", { sel: ".dashboard-fg" }, /* @__PURE__ */ jsx(
    "img",
    {
      attrs: {
        src: onboardingDashboard,
        alt: `board`,
        draggable: `false`
      },
      key: "dashboard"
    }
  )))));
  const ProfileBradGif = () => /* @__PURE__ */ jsx("div", { sel: ".images" }, /* @__PURE__ */ jsx("div", { sel: ".image-container" }, /* @__PURE__ */ jsx("div", { sel: ".ellipse-bg" }, /* @__PURE__ */ jsx("div", { sel: ".profile-animated" }, /* @__PURE__ */ jsx("div", { sel: ".profile-img" }, /* @__PURE__ */ jsx(
    "img",
    {
      attrs: {
        src: bradAnimatedGif,
        alt: `brad`,
        draggable: `false`,
        width: 360
      }
    }
  ))))));
  const { step } = this.state;
  const steps = this.getIntroSteps();
  const currentStep = steps[step];
  const buttonSteps = steps.slice(0, -1);
  const IntroContent = () => /* @__PURE__ */ jsx("div", { sel: ".intro-page" }, /* @__PURE__ */ jsx("div", { sel: ".intro-container", class: { "is-full-page": this.attr(`is-full-page`) } }, /* @__PURE__ */ jsx("div", { sel: ".header" }, /* @__PURE__ */ jsx(LanguageSelectorEl, null)), /* @__PURE__ */ jsx("div", { sel: ".steps" }, /* @__PURE__ */ jsx("div", { sel: ".steps-container" }, buttonSteps.map((step2, idx) => /* @__PURE__ */ jsx(StepButton, { index: idx, step: step2 })))), currentStep.name === this.helpers.IntroStepName.Mixpanel ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(OverviewCopy, null), /* @__PURE__ */ jsx(OverviewImages, null)) : currentStep.name === this.helpers.IntroStepName.Users ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(UsersCopy, null), /* @__PURE__ */ jsx(UsersImages, null)) : currentStep.name === this.helpers.IntroStepName.Events ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(EventsCopy, null), /* @__PURE__ */ jsx(EventsImages, null)) : currentStep.name === this.helpers.IntroStepName.Profiles ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ProfilesCopy, null), /* @__PURE__ */ jsx(ProfileBradGif, null)) : currentStep.name === this.helpers.IntroStepName.Complete ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(CompleteCopy, null), /* @__PURE__ */ jsx(CompleteImagesDashboard, null)) : null));
  return this.attr(`is-full-page`) ? /* @__PURE__ */ jsx(IntroContent, null) : /* @__PURE__ */ jsx(
    ModalEl,
    {
      attrs: {
        elref: `introModal`,
        closeable: true,
        open: true,
        "grow-to-content": true
      }
    },
    /* @__PURE__ */ jsx(IntroContent, null)
  );
}
